import * as React from "react";
import classNames from "classnames";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";

import { StoreState } from "../../reducers/root-reducer";
import { Reservation } from "../../api/reservations";
import { ConnectedComposerView } from "../overview/composer-view";
import { DragDropContext } from "react-dnd";
import { ConnectedReservationSlider } from "../overview/reservation-slider";
import { ConnectedAreaSelect } from "../app-bar/area-select";
import { format } from "../../util/date-utility";
import DisabledBackend from "../../dnd/disabled-backend";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Capabilities } from "../../integration/capabilities";
import { ConnectedPlannerList } from "../planner-list";
import { isIPhoneX } from '../../util/device-util';

interface State {
	groupedInquiries: {
		[key: number]: {
			default: Reservation[];
			snoozed: Reservation[];
		};
	};
}

export interface BookingListDialogProps {
	open: boolean;
	onClose: () => void;
}

interface ConnectedBookingListDialogProps extends WithStyles<typeof styles> {
	capabilities: Capabilities;
	selectedDate: Date;
}

type Props = BookingListDialogProps & ConnectedBookingListDialogProps;

export class BookingListDialog extends React.Component<Props, State> {
	private handleCloseClick = () => {
		this.props.onClose();
	};

	public render() {
		const { classes, open, capabilities, selectedDate } = this.props;

		return (
			<Dialog
				className={classes.dialog}
				open={open}
				fullScreen
				fullWidth
				hideBackdrop
			>
				<DialogContent className={classes.dialogContent}>
					<div className={classes.titleBar}>
						<div className={classes.actions}>
							<Typography className={classes.title}>
								Belegung für{" "}
								{format(selectedDate, "DD. MMMM YY")}
							</Typography>
						</div>
						<div className={classes.actions}>
							<IconButton onClick={this.handleCloseClick}>
								<ClearIcon className={classes.icon} />
							</IconButton>
						</div>
					</div>
					<div className={classes.content}>
						<ConnectedPlannerList readOnly={false} />
					</div>
				</DialogContent>
			</Dialog>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	selectedDate: state.date,
	capabilities: state.capabilities
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const styles = (theme: Theme) =>
	createStyles({
		root: {
			flexGrow: 1,
			position: "fixed",
			bottom: 0,
			left: 0,
			width: "100%",
			height: "100%",
			zIndex: theme.zIndex.appBar + 200,
			background: theme.palette.primary.main,
			display: "flex",
			flexDirection: "column",
			transform: "translate3d(0, 105%, 0)",
			transition: "all 0.2s ease-out",
			boxShadow:
				"0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
		},
		rootOpen: {
			transform: "translate3d(0, 0, 0)"
		},
		dialog: {},
		dialogContent: {
			padding: "0 !important",
			background: theme.palette.primary.main,
			display: "flex",
			flexDirection: "column"
		},
		titleBar: {
			height: 48,
			boxShadow: theme.shadows["5"],
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			padding: "0 8px 0 15px",
			position: "relative",
			zIndex: theme.zIndex.appBar,
			color: "white"
		},
		title: {
			color: "white",
			fontSize: "1.2rem",
			fontWeight: 500,
			marginRight: 25
		},
		icon: {
			color: "white"
		},
		actions: {
			display: "flex",
			alignItems: "center"
		},
		content: {
			flexGrow: 1,
			background: "lightgray",
			display: "flex",
			flexDirection: "column",
			position: "relative"
		}
	});

export const ConnectedBookingListDialog = withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(BookingListDialog)
);
